import OfferChoiceController from './controllers/OfferChoiceController';
import CandidateDataCtrl from './controllers/CandidateDataCtrl';
import PriceDataCtrl from './controllers/PriceDataCtrl';
import EducationDataCtrl from './controllers/EducationDataCtrl';
import SummaryDataCtrl from './controllers/SummaryDataCtrl';
import SidebarCtrl from './controllers/SidebarCtrl';
import ProfileCtrl from './controllers/ProfileCtrl';
import RegisterDataCtrl from './controllers/RegisterDataCtrl';
import DashboardProfileCtrl from './controllers/DashboardProfileCtrl';

import FileDirective from './directives/File';
import DetectDragOverDirective from './directives/DetectDragOverDirective';

import UtilsService from './services/utils.service';

import PriceComponent from './components/PriceComponent';
import SelectCustom from './components/SelectCustomComponent';
import uiMask from 'angular-ui-mask';

function clearInputNameForDataLayer(name)
{
  var cleared;
  cleared = name.replace(/candidate\[/i, '');
  cleared = cleared.replace(/\]\[/gi, '.');
  cleared = cleared.replace(/\[/gi, '');
  cleared = cleared.replace(/\]/gi, '');
  return cleared;
}

angular.module('WsbApp', ['ngMaterial', 'ngMessages', uiMask])
  .controller('OfferChoiceController', OfferChoiceController)
  .controller('CandidateDataCtrl', CandidateDataCtrl)
  .controller('PriceDataCtrl', PriceDataCtrl)
  .controller('EducationDataCtrl', EducationDataCtrl)
  .controller('SummaryDataCtrl', SummaryDataCtrl)
  .controller('SidebarCtrl', SidebarCtrl)
  .controller('ProfileCtrl', ProfileCtrl)
  .controller('RegisterDataCtrl', RegisterDataCtrl)
  .controller('DashboardProfileCtrl', DashboardProfileCtrl)
  .component('priceComponent', PriceComponent)
  .component('selectCustom', SelectCustom)
  .directive('file', FileDirective)
  .directive('detectDragOver', DetectDragOverDirective)
  .service('UtilsService', UtilsService); 

(function(){
  $( document ).ready(function(){
      if(!window.datepickerLang) {
        window.datepickerLang = 'pl';
      }
      jQuery('.input-datepicker input').datepicker({
        startView: 2,
        language: window.datepickerLang,
        format: 'yyyy-mm-dd'
      });
      jQuery('.input-datepicker input').on('click tap vclick focus', function (event) { 
        event.stopImmediatePropagation(); 
        event.preventDefault();
        var element = $(this);
        element.removeClass('ng-empty');
        element.addClass('ng-no-empty ng-touched');
        
        setTimeout(function() {
          element.attr('readonly', 'readonly'); 
          element.attr('disabled', 'true'); 
          element.removeClass('ng-empty');
        element.addClass('ng-no-empty');
        }, 100);
        setTimeout(function() {
            element.blur();  
            element.removeAttr('readonly');
            element.removeAttr('disabled');
            element.removeClass('ng-empty');
        element.addClass('ng-no-empty');
        }, 200);

      });
      jQuery('.input-datepicker input').on('focus', function (event) { 
        setTimeout(function() {
          $(this).blur();
        }, 100);
      });

      var $errorInputs = [];
      var checkErrors = function() {
        $errorInputs.splice(0);
        $('form').find('.ng-invalid').off('invalid')
        .bind('invalid', function() {
          let $this = $(this);
          $this.addClass('has-error');
          $errorInputs.push($this);
          if($errorInputs.length === 1) {
            $('html, body').animate({
                scrollTop: $errorInputs[0].offset().top
              }, 2000);
          }
        });
      };
      checkErrors();

      $('.mobile_call_collapse-button').on('click', function(){
        var $container = $(this).parents('.mobile_call');
        $container.toggleClass('mobile_call-is-collapsed');
      });

      $('body').on('focus', 'input', function(){
        var inputName = clearInputNameForDataLayer($(this).attr('name'));

        if (inputName === '') return;

        dataLayer.push({'formFieldName': inputName, 'event': 'formFieldActive'});

      });

      $('body').on('click', '[data-field-name]', function(){
        var inputName = clearInputNameForDataLayer($(this).attr('data-field-name'));

        if (inputName === '') return;

        dataLayer.push({'formFieldName': inputName, 'event': 'formFieldActive'});
      });

      $('body').on('click', '[data-autocomplete-field-name] input', function(){
        var inputName = clearInputNameForDataLayer($(this).parents('[data-autocomplete-field-name]').attr('data-autocomplete-field-name'));

        if (inputName === '') return;

        dataLayer.push({'formFieldName': inputName, 'event': 'formFieldActive'});

      });



      MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
      var trackChange = function(element) {
        var observer = new MutationObserver(function(mutations, observer) {
          if(mutations[0].attributeName === "value") {
            var inputName = clearInputNameForDataLayer($(element).attr('name'));
            if (inputName === '') return;
            dataLayer.push({'formFieldName': inputName, 'event': 'formFieldActive'});
          }
        });
        observer.observe(element, {
          attributes: true
        });
      };
      
      $("[data-field-track-change]").each(function(){
          trackChange( $(this)[0] );
      });

      $('body').on('mouseenter', '.icon_with-tooltip', function(){
        var inputName = clearInputNameForDataLayer($(this).parent().find('input').attr('name'));
        dataLayer.push({'formFieldName': inputName, 'event': 'formQuestionHoover'});
      });
      $('body').on('mouseenter', '.icon_with-tooltip-inline', function(){
        var inputName = clearInputNameForDataLayer($(this).parents('.input_inline').find('input').attr('name'));
        dataLayer.push({'formFieldName': inputName, 'event': 'formQuestionHoover'});
      });
      var inputNamesArr = [];
      setTimeout(function(){
          inputNamesArr.splice(0,inputNamesArr.length);  
        
        $('.has-error input').each(function(index){
          var thisName = $(this).attr('name');
          inputNamesArr.push(clearInputNameForDataLayer(thisName));
        });
        $('.has-error').parent().find("input[type=hidden]").each(function(index){
          var thisName = $(this).attr('name');
            inputNamesArr.push(clearInputNameForDataLayer(thisName));
        });
        if(inputNamesArr.length > 0) {
          var inputNamesStr = inputNamesArr.toString();
          dataLayer.push({'formErrorFieldsName': inputNamesStr, 'event': 'formFieldError'});
        }

      }, 500);
      $('button[type="submit"]').on('click', function(){
        checkErrors();
        $(this).parents('form').find('input.has-error');
        
        setTimeout(function(){  
          inputNamesArr.splice(0,inputNamesArr.length);  
          $errorInputs.forEach(function(el, index) {
            var $el = $(el); 
            if($el.attr('name') !=='') {
              inputNamesArr.push(clearInputNameForDataLayer($el.attr('name')));
            } else {
              inputNamesArr.push(clearInputNameForDataLayer($el.parents('[data-autocomplete-field-name]').attr('data-autocomplete-field-name')));
            }
          });
          if(inputNamesArr.length > 0) {
            var inputNamesStr = inputNamesArr.toString();
            dataLayer.push({'formErrorFieldsName': inputNamesStr, 'event': 'formFieldError'});
          }
      }, 500);
      });

      $('.js-alert-cyrylica').on('click', '.alert-close', function(e){
        e.preventDefault();
        $(this).parents('.js-alert-cyrylica').removeClass('is-active-cyrylica');
      });
      $('.alert, .alert-fixed, .alert-static').on('click', '.alert-close', function(e){
        e.preventDefault();
        $(this).parents('.alert').addClass('is-hidden-alert');
        $(this).parents('.alert-fixed').addClass('is-hidden-alert');
        $(this).parents('.alert-static').addClass('is-hidden-alert');
      });
      $('.confirm-popup').on('click', '.js-close', function(e){
        e.preventDefault();
        $(this).parents('.confirm-popup').removeClass('is-active');
      });
      $("input, textarea").keypress(function(e) {
        var verified = String.fromCharCode(e.which).match(/[абвгдеёжзийклмнопрстуфхцчшщьыъэюяАБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЬЫЪЭЮЯ]/);
        if (verified) {
          e.preventDefault();
          $('.js-alert-cyrylica').addClass('is-active-cyrylica');
          return false;
        }
      });
      $('input, textarea').on('paste', function () {
        var element = this;
        setTimeout(function () {
          var text = $(element).val();
          var verified = text.match(/[абвгдеёжзийклмнопрстуфхцчшщьыъэюяАБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЬЫЪЭЮЯ]/);
          if (verified) {
            $(element).val('');
            $('.js-alert-cyrylica').addClass('is-active-cyrylica');
            return false;
          }
        }, 100);
      });
      $('body').on('click', '[data-modal]', function(e){
        e.preventDefault();
        $($(this).data('modal')).addClass('is-active');
      });

      const handleLogoutCountdownAlert = function () {
          const logoutCountdownAlert = $('#alert-logout-countdown');

          if(!logoutCountdownAlert.length) {
              return;
          }

          const logoutCountdownSeconds = logoutCountdownAlert.data('logout-countdown-seconds');
          const logoutAlertCountdownSeconds = logoutCountdownAlert.data('logout-alert-countdown-seconds');
          const alertLogoutCountdownWrapper = $('#alert-logout-countdown-wrapper');

          if([logoutCountdownSeconds, logoutAlertCountdownSeconds].indexOf(undefined) !== -1
              || !alertLogoutCountdownWrapper.length
          ) {
              return;
          }

          const startTime = new Date();
          const showAlertTimestamp = new Date(
              startTime.getTime() + 1000 * (logoutCountdownSeconds - logoutAlertCountdownSeconds)
          ).getTime();
          const logoutTimestamp = new Date(startTime.getTime() + 1000 * logoutCountdownSeconds).getTime();

          const timer = setInterval(function () {
              const currentTimestamp = (new Date()).getTime();
              const timestampsDiff = logoutTimestamp - currentTimestamp;

              let seconds = parseInt((timestampsDiff / 1000) % 60);
              let minutes = parseInt((timestampsDiff / 1000) / 60);

              minutes = formatTimeFraction(minutes);
              seconds = formatTimeFraction(seconds);

              $('#alert-logout-countdown-time').html(minutes + ":" + seconds);

              if(!alertLogoutCountdownWrapper.is(':visible') && currentTimestamp >= showAlertTimestamp) {
                  alertLogoutCountdownWrapper.slideDown();
              }

              if(currentTimestamp >= logoutTimestamp) {
                  window.location.href = window.logoutUrl;

                  clearInterval(timer);
              }

          }, 1000);
      }

      const formatTimeFraction = function (timeFraction) {
          if(0 >= timeFraction) {
              return '00';
          }

          return 10 > timeFraction ? '0' + timeFraction : timeFraction;
      }

      handleLogoutCountdownAlert();

      $('body').on('click', '#alert-logout-refresh', function(e){
          e.preventDefault();

          window.location.reload();
      });
    }
  );
})();
